import { render, staticRenderFns } from "./PageClients.vue?vue&type=template&id=1dc0f3da"
import script from "./PageClients.vue?vue&type=script&lang=js"
export * from "./PageClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports